module.exports = __webpack_public_path__ + "static/new_york-27c78df050618a05eb2897004a265509.jpg";